
(() => {
 if(customElements.get('ew-offer-widget')) return;
 class EWOffer extends HTMLElement {
  static hours(tags) {
   if(!Array.isArray(tags)) return null;
   const list=tags.filter(t=>typeof t==='string'&&t.startsWith('urgency-'));
   if(list.length!==1)return null;
   const m=/^urgency-(?:(\d+)d(?:-(\d+)h)?|(\d+)h|(\d+))$/.exec(list[0]);
   if(!m)return null;
   const h=m[1]!==undefined?Number(m[1])*24+Number(m[2]||0):m[3]!==undefined?Number(m[3]):Number(m[4])*24;
   return Number.isSafeInteger(h)&&h>=1&&h<=2160?h:null;
  }
  // Separate product tags are the only source of coupon configuration.
  // Never infer a percentage from the coupon name.
  static offer(tags) {
   if(!Array.isArray(tags))return null;
   const codes=tags.filter(t=>typeof t==='string'&&t.startsWith('coupon-'));
   const benefits=tags.filter(t=>typeof t==='string'&&t.startsWith('offer-'));
   if(!codes.length)return benefits.length?null:{mode:'sale'};
   if(codes.length!==1||benefits.length!==1)return null;
   const code=codes[0].slice(7);
   if(!code||code.trim()!==code||/\s/.test(code)||code.length>255)return null;
   const percent=/^offer-percent-(\d+(?:\.\d{1,2})?)$/.exec(benefits[0]);
   if(percent){const value=Number(percent[1]);return value>0&&value<=100?{mode:'coupon',code,kind:'percent',value}:null;}
   const amount=/^offer-amount-(\d+(?:\.\d{1,2})?)$/.exec(benefits[0]);
   if(amount){const value=Number(amount[1]);return Number.isFinite(value)&&value>0&&value<=1000000?{mode:'coupon',code,kind:'amount',value}:null;}
   return null;
  }
  static savings(v) {
   const price=Number(v?.price),compare=Number(v?.compare);
   if(!Number.isSafeInteger(price)||!Number.isSafeInteger(compare)||price<0||compare<=price)return null;
   return {amount:compare-price,percent:Math.floor((compare-price)*100/compare)};
  }
  connectedCallback() {
   this.hidden=true;
   try{this.config=JSON.parse(this.querySelector('[data-config]').textContent);}catch{return;}
   const c=this.config,h=EWOffer.hours(c.tags),start=Number(c.start)*1000;
   const offer=EWOffer.offer(c.tags);
   if(h===null||!Number.isFinite(start)||start<=0||!offer)return;
   Object.assign(c,offer);
   if(c.mode==='coupon'&&c.kind==='amount'&&c.currency!==c.baseCurrency)return;
   this.start=start;this.end=start+h*3600000;
   if(!Number.isFinite(this.end)||this.end>8640000000000000)return;
   this.scope=this.closest('product-info')||this.closest('.shopify-section')||document;
   const date=new Intl.DateTimeFormat('en-US',{dateStyle:'medium',timeStyle:'short',timeZone:'America/Los_Angeles'}).format(new Date(this.end));
   this.querySelector('[data-end]').textContent=date+' (Pacific Time)';
   this.querySelector('[data-end]').dateTime=new Date(this.end).toISOString();
   this.querySelector('[data-accessible]').textContent='Offer ends '+date+' Pacific Time.';
   this.querySelector('[data-terms]').textContent=c.terms||'';
   this.querySelector('[data-terms]').hidden=!c.terms;
   this.copyHandler=()=>this.copy();
   this.querySelector('[data-copy]').addEventListener('click',this.copyHandler);
   this.variantHandler=e=>{if(String(e.detail?.productId)===String(c.productId)){this.forcedVariant=String(e.detail.variantId||'');this.refresh();}};
   document.addEventListener('ew:variant-change',this.variantHandler);
   this.refresh();this.interval=setInterval(()=>this.refresh(),500);
  }
  selectedId() {
   if(this.forcedVariant!==undefined)return this.forcedVariant;
   if(this.config.demoSelector)return document.querySelector(this.config.demoSelector)?.value||'';
   const inputs=[...this.scope.querySelectorAll('form[action*="/cart/add"] [name="id"]')];
   const enabled=inputs.find(el=>!el.disabled);
   if(enabled)return String(enabled.value||'');
   if(inputs.length)return '';
   return ''; // Require a product form or explicit variant adapter.
  }
  refresh() {
   const c=this.config,now=Date.now();
   if(now<this.start||now>=this.end){this.hidden=true;return;}
   const id=this.selectedId(),v=(c.variants||[]).find(v=>String(v.id)===id);
   if(!v?.available){this.hidden=true;return;}
   const coupon=c.mode==='coupon',saving=EWOffer.savings(v);
   if(!coupon&&!saving){this.hidden=true;return;}
   if(id!==this.lastId){this.querySelector('[data-status]').textContent='';this.querySelector('[data-manual]').hidden=true;}
   this.lastId=id;
   const money=value=>new Intl.NumberFormat(c.locale||'en-US',{style:'currency',currency:c.currency||'USD'}).format(value/100);
   this.querySelector('[data-title]').textContent=coupon?(c.kind==='percent'?'Save '+c.value+'% with code':'Save '+money(Math.round(c.value*100))+' with code'):(saving.percent>=1?'Save '+saving.percent+'%':'Special price');
   this.querySelector('[data-detail]').textContent=coupon?'Use the code at checkout.':(c.showAmount===false?'Now '+money(v.price):money(saving.amount)+' off · Now '+money(v.price));
   this.querySelector('[data-copy]').hidden=c.showCopy===false;
   this.querySelector('[data-coupon]').hidden=!coupon;
   this.querySelector('[data-code]').textContent=c.code||'';
   const mins=Math.ceil((this.end-now)/60000);
   for(const [key,val] of Object.entries({days:Math.floor(mins/1440),hours:Math.floor(mins%1440/60),minutes:mins%60}))this.querySelector('[data-'+key+']').textContent=String(val).padStart(2,'0');
   this.hidden=false;
  }
  async copy() {
   const status=this.querySelector('[data-status]');
   try{await navigator.clipboard.writeText(this.config.code);status.textContent='Code copied. Paste it at checkout.';}
   catch{const input=this.querySelector('[data-manual]');input.hidden=false;input.value=this.config.code;input.focus();input.select();status.textContent='Select and copy this code, then paste it at checkout.';}
  }
  disconnectedCallback(){clearInterval(this.interval);document.removeEventListener('ew:variant-change',this.variantHandler);this.querySelector('[data-copy]')?.removeEventListener('click',this.copyHandler);}
 }
 customElements.define('ew-offer-widget',EWOffer);
})();
